// Packages and components
import { useContext, useEffect, useState } from 'react';

// Helpers and utilities
import { AppHostContext } from '@services/appHost';
import { isMobile } from '@helpers/browserDetect';
import { strogging } from '@shd/jslib/infra';

export const useIsAndroid = () => {
  // Constants
  const appHost = useContext(AppHostContext);
  const appHostService = appHost.isHosted ? appHost.service : undefined;

  // States
  const [isAndroid, setIsAndroid] = useState<boolean>(false);

  // Effects
  useEffect(() => {
    const isHostedAndroid = async () => {
      const res = await appHostService?.requests.fetchOS();
      return res === 'android';
    };

    const isAndroidDevice = async () => {
      if (appHost.isHosted) {
        const test = await isHostedAndroid();
        setIsAndroid(test);
      }

      if (isMobile.Android()) {
        strogging.log('fetchPlatformOS-res', isMobile.Android());
        setIsAndroid(true);
      }
    };
    isAndroidDevice();
  }, [appHost.isHosted, appHostService]);

  return { isAndroid };
};
